module.exports = Object.freeze({ SHIPPING: 'shipping' })
